import React from 'react'
import DuplicateModal from '../../../../../Components/Common/DuplicateModal'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect';
import { setCreatives, setFilteredCreatives, setScrolledCreatives } from '../../../../../slices/campaigns/reducer';
import { duplicateCreative, updateVersionStatusAfterUpdate } from '../../../../../slices/campaigns/thunk';
import { toggleDuplicateCreativeModal } from '../../../../../slices/modals/reducer';

function DuplicateCreativeModal() {
  const dispatch = useDispatch();

  const selectStates = createSelector(state => state, state => ({
    modalState: state.Modal.duplicateCreativeModal,
    creativeToBeDuplicate: state.Campaign.duplicateCreative,
    currentCampaign: state.Campaign.currentCampaign,
    creatives: state.Campaign.creatives,
    filteredCreatives: state.Campaign.filteredCreatives,
    scrolledCreatives: state.Campaign.scrolledCreatives,
  }));
  const { modalState, creativeToBeDuplicate, currentCampaign, creatives, filteredCreatives, scrolledCreatives } = useSelector(selectStates);

  async function duplicateCreativeHandler() {
    const response = await dispatch(duplicateCreative(creativeToBeDuplicate._id));
    if (response.status === 'ok') {
      if (currentCampaign?.bannerType === 'html') {
        const duplicatedCreative = { ...response.data[0] };
        if (duplicatedCreative) {
          dispatch(setCreatives([...creatives, duplicatedCreative]));
          dispatch(setFilteredCreatives([...filteredCreatives, duplicatedCreative]));
          dispatch(setScrolledCreatives([...scrolledCreatives, duplicatedCreative]));
        }
      } else {
        const duplicatedCreative = { ...creativeToBeDuplicate, _id: response.data.insertedIds['0'] };
        if (duplicatedCreative) {
          dispatch(setCreatives([...creatives, duplicatedCreative]));
          dispatch(setFilteredCreatives([...filteredCreatives, duplicatedCreative]));
        }
      }
    }
    dispatch(toggleDuplicateCreativeModal());
  }

  return (
    <DuplicateModal show={modalState}
      onCloseClick={() => dispatch(toggleDuplicateCreativeModal())}
      onDeleteClick={() => duplicateCreativeHandler()} />
  )
}

export default DuplicateCreativeModal
